// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDGsLFTxXzTOfquPVmxxgvYm2e7QTtRE_M",
  authDomain: "tool-9bd22.firebaseapp.com",
  projectId: "tool-9bd22",
  storageBucket: "tool-9bd22.appspot.com",
  messagingSenderId: "958961492727",
  appId: "1:958961492727:web:5499a821df292514cf29f2",
  measurementId: "G-72N3Q3ZCER"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;